import domready from "domready";
import "../vendor/clamp";

function ctaContent(cta, reviewText) {
  if (reviewText.classList.contains('review__text--short')) {
    cta.innerHTML = cta.dataset.less;
  } else {
    cta.innerHTML = cta.dataset.more;
  }
}

domready(() => {
  const reviewTexts = document.querySelectorAll('.review__text');
  if (!reviewTexts) return;

  reviewTexts.forEach((reviewText) => {
    const cta = reviewText.querySelector('.review__cta');
    const review = reviewText.children[0];
    const reviewInfo = reviewText.querySelector('.review__item-info');

    if (review.offsetHeight < review.scrollHeight || reviewText.children[1] !== reviewInfo) {
      cta.innerHTML = cta.dataset.more;
      cta.style.display = '';
      cta.addEventListener('click', () => {
        ctaContent(cta, reviewText);
        reviewText.classList.toggle('review__text--short');
      });
    }
  });
});
